import { render, staticRenderFns } from "./AskOpinion.vue?vue&type=template&id=c1493b1c&scoped=true&"
import script from "./AskOpinion.vue?vue&type=script&lang=ts&"
export * from "./AskOpinion.vue?vue&type=script&lang=ts&"
import style0 from "./AskOpinion.vue?vue&type=style&index=0&id=c1493b1c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1493b1c",
  null
  
)

export default component.exports